import React, { useCallback } from 'react';
import { Button } from '../../Button';
import IconClose from '../../internal/icons/Close';
import { useTranslation } from '../../hooks/useTranslation';
export default function ClearButton({ className }) {
    const { t } = useTranslation('Input');
    const mounted = useCallback((e) => {
        // This should not happen because we always use the component inside rc-input
        // istanbul ignore next
        if (e?.parentElement) {
            // Ignore the role set by rc-input
            e.parentElement.removeAttribute('role');
            // Voice Over will announce a "group" if the tabIndex is not empty, even -1
            e.parentElement.removeAttribute('tabindex');
        }
    }, []);
    return (React.createElement(Button, { variant: "icon", type: "tertiary", size: "small", className: className, "aria-label": t('clear'), ref: mounted },
        React.createElement(IconClose, { "aria-hidden": true })));
}
